module.exports = __webpack_public_path__ + "static/media/HUANJING 1A (HJ-1A).68a7e7b0.czml";